export default __webpack_public_path__ + "static/media/single-project-page-05-img-13.181dd30b.jpg";